import styled from '@emotion/styled';
import { createElement, FC } from 'react';

type Props = {
  className?: string;
};

const OwnedMediaDevice169: FC<Props> = (props) => (
  <Root viewBox="0 0 145.78 300.88" {...props}>
    <defs>
      <style>{'.owned16-9_svg__cls-3{fill:#eee}.owned16-9_svg__cls-4{fill:#a0a0a0}'}</style>
    </defs>
    <g id="owned16-9_svg__\u30EC\u30A4\u30E4\u30FC_2" data-name="\u30EC\u30A4\u30E4\u30FC 2">
      <g id="owned16-9_svg__\u30EC\u30A4\u30E4\u30FC_1-2" data-name="\u30EC\u30A4\u30E4\u30FC 1">
        <rect width={145.78} height={300.88} rx={21.72} />
        <path
          d="M124 7.33h-14.16v1.92a7.59 7.59 0 01-7.59 7.59H43.14a7.59 7.59 0 01-7.59-7.59V7.33h-15A14.31 14.31 0 006.28 21.64v257.6a14.31 14.31 0 0014.31 14.31H124a14.31 14.31 0 0014.31-14.31V21.64A14.31 14.31 0 00124 7.33z"
          fill="#fff"
        />
        <rect x={53.71} y={286.02} width={34.73} height={3.52} rx={1.76} />
        <path fill="#424242" d="M6.28 30.14h132.01v73.17H6.28z" />
        <path
          className="owned16-9_svg__cls-3"
          d="M10.83 160.21h34.5v3.94h-34.5zM10.84 154.2h55.43v4.21H10.84zM73.87 160.21h34.5v3.94h-34.5zM73.88 154.2h55.43v4.21H73.88z"
        />
        <path
          className="owned16-9_svg__cls-4"
          d="M10.66 116.03h57.88v32.08H10.66zM10.66 186.51H131.7v42.71H10.66zM73.7 116.03h57.88v32.08H73.7z"
        />
        <path fill="none" stroke="#f5f5f5" strokeMiterlimit={10} d="M7.51 175.11h130.47" />
        <path
          className="owned16-9_svg__cls-3"
          d="M10.22 264.46h8.63v3.94h-8.63zM10.22 234.5h122.61v4.21H10.22zM10.22 254.7h122.61v4.21H10.22zM10.22 244.06h117.91v4.21H10.22z"
        />
      </g>
    </g>
  </Root>
);

const Root = styled('svg')();

export default OwnedMediaDevice169;
